import { ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, useEventCallback } from '@mui/material';
import { memo, useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { FormikErrors, FormikTouched, useFormikContext } from 'formik';
import CivilStatusForm from './form';
import { AccordionTitle } from 'shell/components/shared/accordion-title';
import { CancelMarriageFormVM } from 'mutation/view-models/cancel-marriage';
import { AccordionCivilStatusMutation } from 'mutation/view-models/civil-status';

interface CivilStatusProps {
  disabled?: boolean;
}

const CivilStatusComponent = ({ disabled }: CivilStatusProps): React.ReactElement => {
  const [open, setOpen] = useState<boolean>(false);

  const formContext = useFormikContext<CancelMarriageFormVM>();

  const onFieldCivilStatusChange = useEventCallback(
    (
      key: keyof AccordionCivilStatusMutation,
      value: AccordionCivilStatusMutation[keyof AccordionCivilStatusMutation]
    ) => {
      formContext.setFieldValue('civilStatus', {
        ...(formContext.values.civilStatus || {}),
        [key]: value,
      });
    }
  );

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="panel-person-civil-status-content"
        id="panel-person-civil-status-header"
        expandIcon={<ExpandMore />}
      >
        <AccordionTitle>Stato Civile</AccordionTitle>
      </AccordionSummary>
      <AccordionDetails>
        <CivilStatusForm
          values={formContext.values.civilStatus}
          onChange={onFieldCivilStatusChange}
          errors={formContext.errors.civilStatus as FormikErrors<AccordionCivilStatusMutation>}
          touched={
            formContext.touched
              .civilStatus as unknown as FormikTouched<AccordionCivilStatusMutation>
          }
          disabled={disabled}
        />
      </AccordionDetails>
    </Accordion>
  );
};

CivilStatusComponent.displayName = 'Accordion civil status component';

const CivilStatus = memo(CivilStatusComponent);

export default CivilStatus;
